import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from 'components/CustomButtons/Button.js';
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { sendCmd } from 'services/lockers/lockers';
import { commands } from 'variables/commands';
import { sendRabbitCommand, createRabbitPayload } from 'services/actions/actions';

import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const useStyles = theme => ({
    formControl: {
        // margin: theme.spacing(2),
        minWidth: '100% !important',
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    rootCircular: {
        flexGrow: 1,
        backgroundColor: "#f1f1f2"
    },
    iconView: {
        color: "white !important"
    },
    alItems: {
        display: "flex",
        // alignItems: "baseline"
    },
    note: {
        lineHeight: '0.3em'
    }
});

class Action extends Component {

    state = {
        open: false,
        cmd: null,
        openSnackbar: false,
        success: "danger",
        message: "",
        function: {},
        fields: [],
        cmdField: {},
    }

    handleClose = () => {
        this.setState({ open: false, openSnackbar: false });
    }

    handleOpen = () => {
        this.setState({ open: true });
    }

    handleChange = (event) => {
        const obj = event.target.value;

        let cmdField = {};

        for (let index = 0; index < obj.fields?.length; index++) {
            const element = obj.fields[index];
            cmdField[`${element.name}`] = element.value || "";
        }

        // console.log(JSON.stringify(obj), this.state.cmd, this.state.fields, cmdField);

        
        this.setState({ cmd: obj, fields: obj.fields, cmdField: cmdField});
    }


    handleChangeChecked = async (event) => {
        const e = event.target.id ? event.target.id : event.target.name;
        const val = event.target.checked;

        const nval = this.state.fields.find((el) => (el.name == e));
        const value = nval.getValue(val);

        // console.log(JSON.stringify(this.state.allLockersData))
        let objeto = this.state.cmdField;
        objeto[`${e}`] = value;
        console.log(e, value)
        this.setState({cmdField: objeto});

    }

    handleChangeFields = async (event) => {
        const e = event.target.id ? event.target.id : event.target.name;
        const { value, type } = event.target;
        // console.log(JSON.stringify(this.state.allLockersData))
        let objeto = this.state.cmdField;
        objeto[`${e}`] = (type == "number")?parseInt(value):value;
        console.log(e, value)
        this.setState({cmdField: objeto});

    }

    handleSend = () => {
        const payload = createRabbitPayload(this.props.lockerId, this.state.cmd?.function?.CMD, this.state.cmdField)
        // console.log('Payload: ', JSON.stringify(payload));


        sendRabbitCommand(payload, (resp) => {
            
            if (resp) {
                this.setState({ message: 'Comando enviado com sucesso!', success: 'success' });
            } else {
                this.setState({ message: 'Ops o locker não respondeu ao comando!', success: 'danger' });
            }
            this.setState({ openSnackbar: true });
        });
    }

    render() {
        const { classes, lockerName, show } = this.props;
        let { open, cmd, openSnackbar, success, message } = this.state;

        if (!show) return null;

        return (
            <div>
                <Snackbar
                    place="tc"
                    color={success}
                    icon={AddAlert}
                    message={message}
                    open={openSnackbar}
                    closeNotification={this.handleClose}
                    close
                />
                <Card>
                    <CardHeader color="primary">
                        <h4>Envio de comandos</h4>
                        <p>Locker: {lockerName}</p>
                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel id="demo-controlled-open-select-label">Comando</InputLabel>
                                    <Select
                                        labelId="demo-controlled-open-select-label"
                                        id="demo-controlled-open-select"
                                        open={open}
                                        onClose={this.handleClose}
                                        onOpen={this.handleOpen}
                                        value={cmd}
                                        onChange={this.handleChange}
                                    >
                                        <MenuItem value="">
                                            <em>-</em>
                                        </MenuItem>
                                        {
                                            commands.map((item) =>
                                                <MenuItem value={item}>{item.label}</MenuItem>
                                            )
                                        }
                                    </Select>
                                </FormControl>
                            </GridItem>
                            {this.state.fields && this.state.fields.map((nprop, key) => {

                                // console.log(JSON.stringify(nprop));
                                if (nprop.type == "checkbox") {
                                    return (
                                        <GridItem xs={12} sm={12} md={12} key={key}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                    label={nprop.label || nprop.name}
                                                    // id="searchText"
                                                    name={nprop.name}
                                                    // value={(this.state.cmdField[`${nprop.name}`] != null)?this.state.cmdField[`${nprop.name}`]:nprop.value}
                                                    onChange={this.handleChangeChecked}
                                                    defaultChecked
                                                    fullWidth
                                                    >
                                                    </Checkbox>
                                                }
                                                label={(this.state.cmdField[`${nprop.name}`] != null)?this.state.cmdField[`${nprop.name}`]:nprop.value}
                                            />
                                      </GridItem>
                                    );
                                } else {
                                return (
                                    <GridItem xs={12} sm={12} md={12} key={key}>
                                        <TextField
                                        label={nprop.label || nprop.name}
                                        // id="searchText"
                                        type={(nprop?.cast)?nprop.cast:"text"}
                                        name={nprop.name}
                                        value={(this.state.cmdField[`${nprop.name}`] != null)?this.state.cmdField[`${nprop.name}`]:nprop.value}
                                        onChange={this.handleChangeFields}
                                        fullWidth
                                        >
                                        </TextField>
                                  </GridItem>
                                );
                                }
                            })}
                            <GridItem xs={12} sm={12} md={4}>
                                <br></br>
                                <Button onClick={this.handleSend} color="primary" autoFocus>
                                    Enviar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(useStyles)(Action);